import { REFERRAL_ENDPOINTS } from './endpoints.js';
/**
 * Referral API Client
 * Encapsulates all referral-related API calls.
 */
export class ReferralClient {
    constructor(httpClient) {
        this.httpClient = httpClient;
    }
    /**
     * Apply a referral code.
     * Corresponds to: POST /api/referral/apply
     * @param payload - The request body, containing the referral code.
     * @returns The validation result from the backend.
     */
    async apply(payload) {
        // The backend returns a detailed JSON response object on success.
        const response = await this.httpClient.post(REFERRAL_ENDPOINTS.APPLY, payload);
        // The HTTP client layer handles non-2xx responses by throwing an error.
        if (!response.success || !response.data) {
            throw new Error(response.error || 'Failed to apply referral code');
        }
        return response.data;
    }
}
//# sourceMappingURL=client.js.map